import { FEATURE_TOGGLE_SELFSEND } from "../config";

let typeFepa = [];
if (FEATURE_TOGGLE_SELFSEND === "true") {
  typeFepa = [
    { ext: "xml", mime: "text/xml", selfsendfPermission: true },
    { ext: "xml", mime: "application/xml", selfsendfPermission: true },
    { ext: "p7m", mime: "application/pkcs7-mime", selfsendfPermission: true },
    { ext: "p7m", mime: "application/pkcs7", selfsendfPermission: true },
    { ext: "p7m", mime: "application/x-pkcs7-mime", selfsendfPermission: true }
  ];
}

export const acceptedFepa = typeFepa;

export const acceptedDocuments = [
  { ext: "pdf", mime: "application/pdf", selfsendfPermission: false },
  { ext: "jpeg", mime: "image/jpeg", selfsendfPermission: false },
  { ext: "jpg", mime: "image/jpeg", selfsendfPermission: false },
  { ext: "png", mime: "image/png", selfsendfPermission: false },
  { ext: "doc", mime: "application/msoffice", selfsendfPermission: false },
  { ext: "docx", mime: "application/vnd.openxmlformats-officedocument", selfsendfPermission: false },
  { ext: "xls", mime: "application/msoffice", selfsendfPermission: false },
  { ext: "xlsx", mime: "application/vnd.openxmlformats-officedocument", selfsendfPermission: false },
  { ext: "csv", mime: "text/csv", selfsendfPermission: false }
];
